// File: views/Landing/Contact.jsx
import React from 'react';
import styles from '../../styles/LandingPage.module.css';

/**
 * Contact renders the Calendly booking section.
 * Props:
 * - active: currently active section ID
 */
export default function Contact({ active }) {
  const isActive = active === 'contact';

  return (
    <section
      id="contact"
      className={`
        ${styles.scheduleSection}
        ${styles.sec}
        ${isActive ? styles.active : ''}
      `}
      data-anim
      style={{ minHeight: '100vh', overflow: 'hidden' }}
    >
      {/* 
        This wrapper stays in the DOM always,
        but only fades in when `active === 'contact'`
      */}
      <div
        className={`
          ${styles.calendlyContainer}
          ${isActive ? styles.showCalendly : styles.hideCalendly}
        `}
        style={{ overflow: 'hidden', height: '100%' }}
      >
        <iframe
          src="https://calendly.com/brendan-musukomedia/30min?primary_color=1DE9B6&background_color=1A1D21&text_color=F0F0F0"
          style={{
            minWidth: 320,
            width: '100%',
            height: 'calc(var(--vh, 1vh) * 120 + 100px)', // Subtract your navbar/header height
            border: 'none',
            background: 'transparent',
            overflow: 'hidden',
            display: 'block',
          }}
          frameBorder="0"
          title="Book a Call with Musuko Media"
          allowtransparency="true"
        />
      </div>
    </section>
  );
}
